import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import moment from "moment";

import SpinnerSmall from "../generics/SpinnerSmall";

export const InventoryAuditItems = (props) => {
  return (
    <div>
      <table className="table table-striped table-bordered datatable mb-0">
        <thead>
          <tr>
            <th>Id</th>
            <th className="hidden-xxs-down">Item</th>
            <th className="hidden-xs-down">Brand</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <ScannedItems scannedItems={props.list} onRemoveItem={props.onRemoveItem} />
      </table>
    </div>
  );
};

export const EmptyInventoryAuditItems = () => {
  return (
    <div className="shipment-list--empty">
      <div className="fa fa-list-ol icon" aria-hidden="true"></div>
      <div>No items yet</div>
    </div>
  );
};

export const InventoryAuditHeader = (props) => {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4>Inventory Audit #{props.audit.id}</h4>
        {props.showFinish ? (
          <div className="btn btn-primary m-0" onClick={props.finishAudit}>
            <span>
              Finish<i className="fa fa-check ml-05"></i>
            </span>
          </div>
        ) : props.xlsLoading ? (
          <div className="d-flex btn btn-primary disabled mr-05">
            <div className="color-white mr-05">
              <span>Loading Excel</span>
            </div>
            <SpinnerSmall />
          </div>
        ) : (
          <div className="btn btn-primary m-0">
            <div className="color-white mr-05" onClick={props.loadInventoryAuditXLS}>
              <span>Export Excel</span>
            </div>
          </div>
        )}
        {!props.showFinish &&
          (props.r365xlsLoading ? (
            <div className="d-flex btn btn-primary disabled mr-05">
              <div className="color-white mr-05">
                <span>Loading File</span>
              </div>
              <SpinnerSmall />
            </div>
          ) : (
            <div className="btn btn-primary m-0">
              <div className="color-white mr-05" onClick={props.loadInventoryAuditR365}>
                <span>Export R365</span>
              </div>
            </div>
          ))}
        {!props.showFinish &&
          (props.r365UploadLoading ? (
            <div className="d-flex btn btn-primary disabled mr-05">
              <div className="color-white mr-05">
                <span>Loading R365</span>
              </div>
              <SpinnerSmall />
            </div>
          ) : (
            <div className="btn btn-primary m-0">
              <div className="color-white mr-05" onClick={props.loadInventoryAuditUpload}>
                <span>Upload R365</span>
              </div>
            </div>
          ))}
      </div>
      <div className="card-block pb-0">
        <div className="row">
          <div className="col-12 col-sm-4">
            <h4>Created at</h4>
            <p>{moment(props.audit.date_created).format("MM/DD/YYYY HH:mm")}</p>
          </div>
          <div className="col-12 col-sm-4">
            <h4>Status</h4>
            <span className={`badge badge-pill ${props.audit.status === "In progress" ? "badge-warning" : "badge-success"}`}>
              {props.audit.status}
            </span>
          </div>
          <div className="col-12 col-sm-4">
            <h4>Created by</h4>
            <p>{props.audit.created_by}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ScannedItemsTableRow = (props) => {
  return (
    <tr>
      <td>
        {props.item.inventory && (
          <NavLink to={`/inventory/${props.item.inventory.id}`}>{props.item.inventory ? props.item.inventory.id : ""}</NavLink>
        )}
        {!props.item.inventory && props.item.scanned_id}
      </td>
      <td className="hidden-xxs-down">{props.item.inventory ? props.item.inventory.item.name : "NOT FOUND"}</td>
      <td className="hidden-xs-down">{props.item.inventory && props.item.inventory.brand ? props.item.inventory.brand.brand_name : "-"}</td>
      <td>
        {props.item.inventory && (
          <span className={`badge badge-pill ${props.item.inventory.active ? "badge-success" : "badge-danger"}`}>
            {props.item.inventory.active ? "REGISTERED" : "NOT FOUND"}
          </span>
        )}
        {!props.item.inventory && <span className="badge badge-pill badge-danger">"NOT FOUND"</span>}
      </td>
      <td>
        <span className="btn btn-danger" onClick={() => props.onRemoveItem(props.item.id)}>
          <i className="fa fa-trash"></i>
        </span>
      </td>
    </tr>
  );
};

export default class ScannedItems extends Component {
  render() {
    return (
      <tbody>
        {this.props.scannedItems.map((i, idx) => {
          return <ScannedItemsTableRow item={i} onRemoveItem={this.props.onRemoveItem} key={idx} />;
        })}
      </tbody>
    );
  }
}
